export const LP_AFFILIATOR = "/affiliators";
export const USERS_AFFILIATOR = "/users/affiliators";
